import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import moment from "moment";

import { LeftAlignedGrid, RightAlignedGrid, DateText } from "./sharedStyles";

const PaymentDateOnly = ({ result }) => (
  <>
    <LeftAlignedGrid item xs={6}>Next Payment Date</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}><DateText>{moment(result.calculationDate).format("MM/DD/YYYY")}</DateText></RightAlignedGrid>
  </>
);
export default PaymentDateOnly;
